enum CountryCode {
  Canada = 'CA',
  Germany = 'DE',
  Italy = 'IT',
  Mexico = 'MX',
  UnitedKingdom = 'GB',
  UnitedStates = 'US',
}

export { CountryCode };
